# Список коллекций (contents с filter.type: COLLECTION — тип передаёт фича,
# как референсный CollectionsQuery с захардкоженным type: COLLECTION)
query CollectionsList(
  $page: Int
  $rowsPerPage: Int
  $filter: ContentsFilterInput
) {
  contents(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      type
      title
      publishAt
      hideInGeneralLists
      url
      path
      preview {
        id
        url(format: SMALL)
      }
      collectionIds
      productIds
      collectionTypeId
      collectionType {
        id
        title
      }
      collectionContentSort
      tags {
        id
        title
      }
      videosCount: childrenContentsCount(type: VIDEO)
      collectionsCount: childrenContentsCount(type: COLLECTION)
      totalViews
      createdAt
      updatedAt
    }
  }
}
